import React, { useState, useRef } from 'react';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { ARCHIVE_STATUS } from '../../common/constants';
import type { OnSort, OnPageChange, OnFilterChange } from '../../common/types';
import FetchProjectsServiceDI from '../../services/fetch-projects';
import {
	PAGE_LIMIT,
	DEFAULT_SORT_KEY_ARCHIVED,
	DEFAULT_SORT_KEY_DELETED,
	DEFAULT_SORT_ORDER,
} from './constants';
import type { Props, State } from './types';
import { getPageRequest } from './utils';

const TableController = (props: Props) => {
	const { FetchProjectsService, status } = props;
	const [tableState, setTableState] = useState<State>({
		page: 1,
		sort: {
			sortKey: status === ARCHIVE_STATUS ? DEFAULT_SORT_KEY_ARCHIVED : DEFAULT_SORT_KEY_DELETED,
			sortOrder: DEFAULT_SORT_ORDER,
		},
		filters: {
			query: '',
			typeKey: [],
		},
	});
	const { page, sort, filters } = tableState;
	const pageRef = useRef(0);

	const onPageChange: OnPageChange = (_, pageNumber) => {
		setTableState({ ...tableState, page: pageNumber });
	};

	const refetchProjects = (): void => {
		pageRef.current = 0;
		setTableState({ ...tableState, page: 1 });
	};

	// @ts-expect-error - TS7006 - Parameter 'data' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
	const onSort: OnSort = (data, analyticsEvent) => {
		pageRef.current = 0;
		setTableState({
			...tableState,
			page: 1,
			sort: {
				sortKey: data.key,
				sortOrder: data.sortOrder,
			},
		});
		fireUIAnalytics(analyticsEvent, 'tableHeader', { key: data.key });
	};

	const onFilterChange: OnFilterChange = (newFilters) => {
		pageRef.current = 0;
		setTableState({
			...tableState,
			page: 1,
			filters: {
				...tableState.filters,
				...newFilters,
			},
		});
	};

	return (
		<TenantContextSubscriber>
			{({ tenantContext: { baseUrl } }) => (
				<FetchProjectsService baseUrl={baseUrl} status={status}>
					{/* @ts-expect-error - TS2769 - No overload matches this call. */}
					{({ loading, data, error, fetch }) => {
						if (error) {
							return null;
						}

						if (!loading && pageRef.current !== page) {
							pageRef.current = page;
							fetch(getPageRequest(page, PAGE_LIMIT, sort, status, filters));
						}

						return props.children({
							isLoading: loading,
							data,
							page,
							limit: PAGE_LIMIT,
							onPageChange,
							onSort,
							sort,
							refetchProjects,
							onFilterChange,
							filters,
						});
					}}
				</FetchProjectsService>
			)}
		</TenantContextSubscriber>
	);
};

TableController.defaultProps = {
	FetchProjectsService: FetchProjectsServiceDI,
};

export default TableController;
